import styled from '@/styles';

export const PageContent = styled('div', {
  maxWidth: 802,
  margin: '40px auto 60px',
  display: 'flex',
  flexDirection: 'column',
  gap: 40,
  padding: '0 20px',
  boxSizing: 'border-box',
  fontFamily: "'Manrope', sans-serif",
});

export const SectionGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
});

export const SectionTitle = styled('p', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  margin: 0,
});

export const CategoryRow = styled('div', {
  display: 'flex',
  gap: 20,
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const CategoryCard = styled('div', {
  position: 'relative',
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  cursor: 'pointer',
  transition: 'border-color 0.15s',
  flex: '0 0 auto',
  minWidth: 110,
  '&:hover': {
    borderColor: '#44A735',
  },
  variants: {
    selected: {
      true: {
        border: '2px solid #44A735',
        padding: 15,
      },
    },
  },
});

export const CategoryCircle = styled('div', {
  width: 74,
  height: 74,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const CategoryLabel = styled('span', {
  fontSize: 12,
  fontWeight: 400,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  textAlign: 'center',
  variants: {
    selected: { true: { fontWeight: 600 } },
  },
});

export const SkillRow = styled('div', {
  display: 'flex',
  gap: 20,
  alignItems: 'stretch',
  flexWrap: 'wrap',
});

export const SkillCard = styled('div', {
  position: 'relative',
  flex: '0 0 auto',
  width: 'calc(16.666% - 17px)',
  minWidth: 90,
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  cursor: 'pointer',
  transition: 'border-color 0.15s',
  boxSizing: 'border-box',
  '&:hover': {
    borderColor: '#44A735',
  },
  variants: {
    selected: {
      true: {
        border: '2px solid #44A735',
        padding: 15,
      },
    },
  },
});

export const SkillIconWrap = styled('div', {
  width: 54,
  height: 54,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const SkillIconImg = styled('img', {
  width: 54,
  height: 54,
  objectFit: 'contain',
});

export const SkillIconFallback = styled('div', {
  width: 54,
  height: 54,
  borderRadius: '50%',
  background: '#F0F0F0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const SkillLabel = styled('span', {
  fontSize: 12,
  fontWeight: 400,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  textAlign: 'center',
  variants: {
    selected: {
      true: { fontWeight: 600, color: '#44A735' },
    },
  },
});

export const SelectedBadge = styled('div', {
  position: 'absolute',
  top: -7,
  right: -7,
});

export const DetailsCard = styled('div', {
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '24px 32px',
  display: 'flex',
  flexDirection: 'column',
  gap: 40,
});

export const FieldGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
});

export const Field = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  variants: {
    gap: {
      sm: { gap: 4 },
      md: { gap: 8 },
      lg: { gap: 12 },
    },
  },
});

export const FieldHeading = styled('p', {
  fontSize: 14,
  fontWeight: 600,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  margin: 0,
});

export const FieldHint = styled('p', {
  fontSize: 12,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  margin: '2px 0 0',
  lineHeight: 1.4,
});

export const InputShell = styled('div', {
  position: 'relative',
});

export const Select = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 34,
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '0 8px',
  background: '#fff',
  fontFamily: "'Manrope', sans-serif",
  cursor: 'text',
});

export const SelectInput = styled('input', {
  flex: 1,
  padding: '0 8px',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontSize: 14,
  fontFamily: "'Manrope', sans-serif",
  color: '#1C1C1C',
  cursor: 'text',
  '&::placeholder': { color: '#979797' },
});

export const TriggerSelect = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: '1px solid #DADADA',
  borderRadius: 8,
  height: 34,
  padding: '0 10px 0 12px',
  cursor: 'pointer',
  background: '#fff',
  fontFamily: "'Manrope', sans-serif",
});

export const ReadonlyInput = styled('input', {
  width: '100%',
  border: '1px solid #DADADA',
  borderRadius: 8,
  height: 34,
  padding: '0 40px 0 12px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  cursor: 'pointer',
  '&::placeholder': { color: '#979797' },
});

export const TextInput = styled('input', {
  width: '100%',
  border: '1px solid #DADADA',
  borderRadius: 8,
  height: 34,
  padding: '0 12px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  '&::placeholder': { color: '#979797' },
});

export const DropdownPanel = styled('div', {
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  right: 0,
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  zIndex: 50,
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 220,
});

export const DropdownScroll = styled('div', {
  overflowY: 'auto',
  flex: '1 1 auto',
});

export const DropdownItem = styled('div', {
  padding: '10px 16px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  '&:hover': { background: '#F9F9F9' },
});

export const DropdownFooter = styled('div', {
  borderTop: '1px solid #DADADA',
  flexShrink: 0,
  background: '#fff',
});

export const AddRow = styled('div', {
  padding: '10px 16px',
  cursor: 'pointer',
  fontSize: 14,
  color: '#44A735',
  fontFamily: "'Manrope', sans-serif",
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '&:hover': { background: '#F9F9F9' },
});

export const PlusGlyph = styled('span', {
  fontSize: 16,
  lineHeight: 1,
  color: '#44A735',
  flexShrink: 0,
});

export const CaretButton = styled('button', {
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const TextArea = styled('textarea', {
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '12px 16px',
  background: '#fff',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  resize: 'vertical',
  minHeight: 80,
  outline: 'none',
  lineHeight: 1.5,
  width: '100%',
  boxSizing: 'border-box',
  '&::placeholder': { color: '#979797' },
});

export const InstructionActions = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 16,
});

export const LinkButton = styled('button', {
  background: 'transparent',
  border: 'none',
  color: '#2E8722',
  fontSize: 12,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  padding: 0,
});

export const SaveAffordance = styled('div', {
  borderLeft: '1px solid #DADADA',
  paddingLeft: 16,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  variants: {
    disabled: {
      true: {
        opacity: 0.4,
        pointerEvents: 'none',
        cursor: 'default',
      },
    },
  },
});

export const SaveButton = styled('button', {
  background: 'transparent',
  border: 'none',
  fontSize: 12,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  padding: 0,
  variants: {
    disabled: {
      true: { color: '#979797' },
      false: { color: '#2E8722' },
    },
  },
});

export const SupervisorOtherFields = styled('div', {
  borderLeft: '3px solid #44A735',
  paddingLeft: 14,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const PrimaryButton = styled('button', {
  background: '#44A735',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '7px 18px',
  fontSize: 13,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  '&:hover': { background: '#2E8722' },
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
});

export const SecondaryButton = styled('button', {
  background: 'transparent',
  color: '#5B5B5B',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '7px 14px',
  fontSize: 13,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
});

export const NoContactRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: 0,
  alignItems: 'stretch',
  paddingLeft: 20,
});

export const NoContactDivider = styled('div', {
  width: 1,
  background: '#DADADA',
  flexShrink: 0,
  marginRight: 12,
});

export const ToggleRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 0',
});

export const ToggleLabel = styled('p', {
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  margin: 0,
});

export const ToggleSwitch = styled('button', {
  position: 'relative',
  width: 44,
  height: 24,
  border: 'none',
  borderRadius: 100,
  cursor: 'pointer',
  flexShrink: 0,
  marginLeft: 16,
  transition: 'background 0.2s',
  variants: {
    on: {
      true: { background: '#44A735' },
      false: { background: '#DADADA' },
    },
  },
});

export const ToggleKnob = styled('div', {
  position: 'absolute',
  top: 3,
  width: 18,
  height: 18,
  background: '#fff',
  borderRadius: '50%',
  transition: 'all 0.2s',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  variants: {
    on: {
      true: { right: 3 },
      false: { right: 23 },
    },
  },
});

export const SelectedSkillCategoryNote = styled('p', {
  fontSize: 12,
  color: '#979797',
  fontFamily: "'Manrope', sans-serif",
  margin: 0,
});
